"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const agent_1 = require("@dfinity/agent");
const principal_1 = require("@dfinity/principal");
const idl_1 = require("./chats/candid/idl");
const idl_2 = require("./p2p/candid/idl");
const idl_3 = require("./userMgmt/candid/idl");
const idl_4 = require("./notifications/candid/idl");
class CanisterClientFactory {
    constructor(agent) {
        let chatsId = principal_1.Principal.fromText(process.env.CHATS_CANISTER_ID);
        let p2pId = principal_1.Principal.fromText(process.env.P2P_CANISTER_ID);
        let userMgmtId = principal_1.Principal.fromText(process.env.USER_MGMT_CANISTER_ID);
        let notificationsId = principal_1.Principal.fromText(process.env.NOTIFICATIONS_CANISTER_ID);
        this._chatsActor = this.createActor(agent, chatsId, idl_1.idlFactory);
        this._p2pActor = this.createActor(agent, p2pId, idl_2.idlFactory);
        this._userMgmtActor = this.createActor(agent, userMgmtId, idl_3.idlFactory);
        this._notificationsActor = this.createActor(agent, notificationsId, idl_4.idlFactory);
    }
    get chatsClient() {
        return this._chatsActor;
    }
    get p2pClient() {
        return this._p2pActor;
    }
    get userMgmtClient() {
        return this._userMgmtActor;
    }
    get notificationsClient() {
        return this._notificationsActor;
    }
    static get current() {
        return window.canisterClientFactory;
    }
    static set current(value) {
        window.canisterClientFactory = value;
    }
    createActor(agent, canisterId, factory) {
        return agent_1.Actor.createActor(factory, {
            agent,
            canisterId,
        });
    }
}
exports.default = CanisterClientFactory;
CanisterClientFactory.init = (identity) => __awaiter(void 0, void 0, void 0, function* () {
    if (identity.getPrincipal().isAnonymous()) {
        throw new Error("Cannot use the anonymous identity");
    }
    const agent = new agent_1.HttpAgent({ identity });
    // Fetch root key for certificate validation during development
    if (process.env.NODE_ENV !== "production") {
        agent.fetchRootKey();
    }
    CanisterClientFactory.current = new CanisterClientFactory(agent);
});
